export { default, SubscriptionTable } from './SubscriptionTable';



// WEBPACK FOOTER //
// ./app/components/shared/SubscriptionTable/index.js